module.exports = __webpack_public_path__ + "img/28_3.a95d1c35.png";